import { render, staticRenderFns } from "./PlanoCreate.vue?vue&type=template&id=465c0fd8&"
import script from "./PlanoCreate.vue?vue&type=script&lang=js&"
export * from "./PlanoCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports